import * as React from 'react'
import Annotation from 'components/Annotation'

interface Props {
  name: string
  value?: string
  label: string
  placeholder?: string
  bold?: boolean
  className?: string
  style?: React.CSSProperties
  setValue?: (value: string) => void
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  notes?: string[]
  errors?: string[]
  rows?: number
}

const Component: React.FC<Props> = ({ name, value, label, placeholder, bold, className, style, setValue, onChange, notes, errors, rows }) => {
  const originalOnChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (setValue) {
      setValue(event.target.value)
    }
    if (onChange) {
      onChange(event)
    }
  }
  const noteList = (notes ?? []).filter(Boolean)
  const errorList = (errors ?? []).filter(Boolean)
  return (
    <div id={`input_item_id_${name}`} className={className} style={style}>
      <label className={`${bold ? 'fw-bold ' : ''}font-15`}>{label}</label>
      <div>
        <textarea
          name={name}
          className={`textarea${errorList.length > 0 ? ' border-danger border-2' : ''}`}
          placeholder={placeholder}
          value={value}
          onChange={originalOnChange}
          rows={rows}
        />
      </div>
      {noteList.length > 0 && <Annotation notes={noteList} />}
      {errorList.length > 0 && <Annotation notes={errorList} warn />}
    </div>
  )
}

export default Component
